export enum SchemaFields {
    generateWebsiteSchema = 'generateWebsiteSchema',
    generateOrganizationSchema = 'generateOrganizationSchema',
    generateWebPageSchema = 'generateWebPageSchema',
    generateSoftwareApplicationSchema = 'generateSoftwareApplicationSchema',
    generateBlogPageSchema = 'generateBlogPageSchema',
    generateBlogPostSchema = 'generateBlogPostSchema',
    generateFAQSchema = 'generateFAQSchema'
};

export interface FAQItem {
    question: string;
    answer: string;
}